import { render } from "./appSidebar.vue?vue&type=template&id=1f85ef0d&scoped=true"
import script from "./appSidebar.vue?vue&type=script&lang=js"
export * from "./appSidebar.vue?vue&type=script&lang=js"

import "./appSidebar.vue?vue&type=style&index=0&id=1f85ef0d&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f85ef0d"]])

export default __exports__